import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom"; // Use navigate instead of history
import { SubmitButton } from "../../components/Input";
import StateManagedSelect from "react-select";
import { API_URL } from "../../config";
import axios from "axios";
import { showToast } from "../../components/toast";

const AddLeadCreationStreetfolioForm = () => {
  const [workflowName, setWorkflowName] = useState("");
  const [dropdowns, setDropdowns] = useState({
    sources: [],
    smsTemplates: [{ value: 0, label: "Select" }],
    pushTemplates: [{ value: 0, label: "Select" }],
    users: [],
    leadSources: [{ value: 0, label: "Select" }],
    userSources: [{ value: 0, label: "Select" }],
    whatsappTemplates: [{ value: 0, label: "Select" }],
    emailTemplates: [{ value: 0, label: "Select" }],
    languageList: [],
  });

  const [selectedLanguageOption, setSelectedLanguageOption] = useState(null);

  const [selectedLeadSourceOptions, setSelectedLeadSourceOptions] =
    useState(null);
  const [selectedAllotToUserOptions, setSelectedAllotToUserOptions] = useState(
    []
  );
  const [
    selectedAlertLeadSmsSourceSubscriberOption,
    setSelectedAlertLeadSmsSourceSubscriberOption,
  ] = useState(0);
  const [
    selectedAlertLeadSmsSubscriberOption,
    setSelectedAlertLeadSmsSubscriberOption,
  ] = useState(0);
  const [
    selectedAlertLeadPushSubscriberOption,
    setSelectedAlertLeadPushSubscriberOption,
  ] = useState(0);
  const [
    selectedAlertUserSmsSourceExecutiveOption,
    setSelectedAlertUserSmsSourceExecutiveOption,
  ] = useState(0);
  const [
    selectedAlertLeadSmsExecutiveOption,
    setSelectedAlertLeadSmsExecutiveOption,
  ] = useState(0);
  const [
    selectedAlertUserPushExecutiveOption,
    setSelectedAlertUserPushExecutiveOption,
  ] = useState(0);
  const [
    selectedAlertLeadWhatsappSubscriberOption,
    setSelectedAlertLeadWhatsappSubscriberOption,
  ] = useState(0);
  const [
    selectedAlertUserWhatsappExecutiveOption,
    setSelectedAlertUserWhatsappExecutiveOption,
  ] = useState(0);
  const [
    selectedAlertLeadEmailSubscriberOption,
    setSelectedAlertLeadEmailSubscriberOption,
  ] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();
  const { id } = useParams();

  const fetchDropdowns = async () => {
    try {
      const response = await axios.get(`${API_URL}leadCreationstreet/dropdowns`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const data = response.data.data;
      setDropdowns({
        sources: data.sourcelist.map((item) => ({
          value: item.id,
          label: item.name,
        })),
        smsTemplates: [
          { value: 0, label: "Select" },
          ...(data.smslist || []).map((item) => ({
            value: item.id,
            label: item.name,
          })),
        ],
        pushTemplates: [
          { value: 0, label: "Select" },
          ...(data.pushlist || []).map((item) => ({
            value: item.id,
            label: item.name,
          })),
        ],
        users: (data.userlist || []).map((item) => ({
          value: item.id,
          label: item.name,
        })),
        leadSources: [
          { value: 0, label: "Select" },
          ...(data.leadsourcelist || []).map((item) => ({
            value: item.id,
            label: item.name,
          })),
        ],
        userSources: [
          { value: 0, label: "Select" },
          ...(data.usersourcelist || []).map((item) => ({
            value: item.id,
            label: item.name,
          })),
        ],
        whatsappTemplates: [
          { value: 0, label: "Select" },
          ...(data.whatsapppushlist || []).map((item) => ({
            value: item.id,
            label: item.name,
          })),
        ],
        emailTemplates: [
          { value: 0, label: "Select" },
          ...(data.emailtemplatelist || []).map((item) => ({
            value: item.id,
            label: item.name,
          })),
        ],
        languageList: (data.languagelist || data.languageList || []).map((item) => ({
          value: item.id,
          label: item.name,
        })),
      });
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchLead = async () => {
    try {
      const response = await axios.get(`${API_URL}leadCreationstreet`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const data = response.data.data.data.filter((dt) => dt.id == id);
      const lead = data[0];
      setWorkflowName(lead.workflow_name || "");
      setSelectedLeadSourceOptions(lead.lead_source || null);

      const preSelectedUserIds = lead.allot_to_user?.split(",") || [];
      const matchedOptions = dropdowns.users.filter((option) =>
        preSelectedUserIds.includes(String(option.value))
      );
      setSelectedAllotToUserOptions(matchedOptions);

      setSelectedAlertLeadSmsSourceSubscriberOption(
        lead.alert_lead_sms_source !== undefined && lead.alert_lead_sms_source !== null
          ? lead.alert_lead_sms_source
          : 0
      );
      setSelectedAlertLeadSmsSubscriberOption(
        lead.alert_lead_sms !== undefined && lead.alert_lead_sms !== null
          ? lead.alert_lead_sms
          : 0
      );
      setSelectedAlertLeadPushSubscriberOption(
        lead.alert_lead_push !== undefined && lead.alert_lead_push !== null
          ? lead.alert_lead_push
          : 0
      );
      setSelectedAlertUserSmsSourceExecutiveOption(
        lead.alert_user_sms_source !== undefined && lead.alert_user_sms_source !== null
          ? lead.alert_user_sms_source
          : 0
      );
      setSelectedAlertLeadSmsExecutiveOption(
        lead.alert_user_sms !== undefined && lead.alert_user_sms !== null
          ? lead.alert_user_sms
          : 0
      );
      setSelectedAlertUserPushExecutiveOption(
        lead.alert_user_push !== undefined && lead.alert_user_push !== null
          ? lead.alert_user_push
          : 0
      );
      setSelectedAlertLeadWhatsappSubscriberOption(
        lead.alert_lead_whatsapp_push !== undefined && lead.alert_lead_whatsapp_push !== null
          ? lead.alert_lead_whatsapp_push
          : 0
      );
      setSelectedAlertUserWhatsappExecutiveOption(
        lead.alert_user_whatsapp_push !== undefined && lead.alert_user_whatsapp_push !== null
          ? lead.alert_user_whatsapp_push
          : 0
      );
      setSelectedAlertLeadEmailSubscriberOption(
        lead.alert_lead_email !== undefined && lead.alert_lead_email !== null
          ? lead.alert_lead_email
          : 0
      );
      setSelectedLanguageOption(lead.language || null);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDropdowns();
  }, []);

  useEffect(() => {
    if (id && !isNaN(id) && dropdowns.users.length > 0) {
      fetchLead();
    }
  }, [id, dropdowns.users.length]);

  const handleMultiSelectChange = (selectedOptions) => {
    setSelectedAllotToUserOptions(selectedOptions || []);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      workflow_name: workflowName,
      lead_source: selectedLeadSourceOptions,
      allot_to_user: selectedAllotToUserOptions.map((option) => option.value),
      alert_lead_sms_source: selectedAlertLeadSmsSourceSubscriberOption || 0,
      alert_lead_sms: selectedAlertLeadSmsSubscriberOption || 0,
      alert_lead_push: selectedAlertLeadPushSubscriberOption || 0,
      alert_user_sms_source: selectedAlertUserSmsSourceExecutiveOption || 0,
      alert_user_sms: selectedAlertLeadSmsExecutiveOption || 0,
      alert_user_push: selectedAlertUserPushExecutiveOption || 0,
      alert_lead_whatsapp_push: selectedAlertLeadWhatsappSubscriberOption || 0,
      alert_user_whatsapp_push: selectedAlertUserWhatsappExecutiveOption || 0,
      alert_lead_email: selectedAlertLeadEmailSubscriberOption || 0,
      language: selectedLanguageOption || 0,
    };

    try {
      const url = id
        ? `${API_URL}leadCreationstreet/save?id=${id}`
        : `${API_URL}leadCreationstreet/save`;

      const response = await axios.post(url, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 201) {
        showToast.success(response.data.message);
        navigate("/Workflow/LeadCreation");
      }
    } catch (error) {
      console.error("Error saving notification:", error);
      showToast.error("There was an error saving the notification");
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      {/* Include your header here */}
      <div id="content" className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <form name="frm1" onSubmit={handleSubmit} className="stdform">
            <input type="hidden" name="id" value={id} />
            <div className="panel-heading border-0">
              <span className="panel-title">
                {id ? "Edit " : "Add "} Workflow Lead Creation - Streetfolio
              </span>
            </div>
            <div className="panel-body">
              <div className="row">
                <div className="col-md-4">
                  <label>Workflow Name</label>
                  <input
                    type="text"
                    placeholder="Enter Workflow Name"
                    className="form-control"
                    value={workflowName}
                    onChange={(e) => setWorkflowName(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-md-12 my-2">
                <span className="panel-title">Workflow:</span>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <label>Lead Source</label>
                  <StateManagedSelect
                    options={dropdowns.sources}
                    value={
                      selectedLeadSourceOptions
                        ? dropdowns.sources.find(
                          (option) =>
                            option.value == selectedLeadSourceOptions
                        )
                        : null
                    }
                    onChange={(selected) =>
                      setSelectedLeadSourceOptions(selected?.value)
                    }
                    placeholder="--select--"
                  />
                </div>
                <div className="col-md-4">
                  <label>Allocation To SM</label>
                  <StateManagedSelect
                    options={dropdowns.users}
                    isMulti
                    value={selectedAllotToUserOptions}
                    onChange={handleMultiSelectChange}
                    placeholder="Select Users"
                  />
                </div>
                <div className="col-md-4">
                  <label>Language</label>
                  <StateManagedSelect
                    options={dropdowns.languageList}
                    value={
                      selectedLanguageOption
                        ? dropdowns.languageList.find(
                            (option) =>
                              option.value == selectedLanguageOption
                          )
                        : null
                    }
                    onChange={(selected) =>
                      setSelectedLanguageOption(selected?.value)
                    }
                    placeholder="--select--"
                    isClearable
                  />
                </div>
              </div>
              {/* <div className="col-md-12 my-2">
                <span className="panel-title">Alerts:</span>
              </div>
              <div className="row g-3">
                <div className="col-md-4">
                  <label>Alert Lead Sms Source Subscriber</label>
                  <StateManagedSelect
                    options={dropdowns.leadSources}
                    value={
                      selectedAlertLeadSmsSourceSubscriberOption !== null &&
                      selectedAlertLeadSmsSourceSubscriberOption !== undefined
                        ? dropdowns.leadSources.find(
                            (option) =>
                              option.value ==
                              selectedAlertLeadSmsSourceSubscriberOption
                          ) || null
                        : null
                    }
                    onChange={(selected) =>
                      setSelectedAlertLeadSmsSourceSubscriberOption(
                        selected ? selected.value : 0
                      )
                    }
                    placeholder="--select--"
                  />
                </div>
                <div className="col-md-4">
                  <label>Alert Lead Sms Subscriber</label>
                  <StateManagedSelect
                    options={dropdowns.smsTemplates}
                    value={
                      selectedAlertLeadSmsSubscriberOption !== null &&
                      selectedAlertLeadSmsSubscriberOption !== undefined
                        ? dropdowns.smsTemplates.find(
                            (option) =>
                              option.value ==
                              selectedAlertLeadSmsSubscriberOption
                          ) || null
                        : null
                    }
                    onChange={(selected) =>
                      setSelectedAlertLeadSmsSubscriberOption(
                        selected ? selected.value : 0
                      )
                    }
                    placeholder="--select--"
                  />
                </div>
                <div className="col-md-4">
                  <label>Alert Lead Push Subscriber</label>
                  <StateManagedSelect
                    options={dropdowns.pushTemplates}
                    value={
                      selectedAlertLeadPushSubscriberOption !== null &&
                      selectedAlertLeadPushSubscriberOption !== undefined
                        ? dropdowns.pushTemplates.find(
                            (option) =>
                              option.value ==
                              selectedAlertLeadPushSubscriberOption
                          ) || null
                        : null
                    }
                    onChange={(selected) =>
                      setSelectedAlertLeadPushSubscriberOption(
                        selected ? selected.value : 0
                      )
                    }
                    placeholder="--select--"
                  />
                </div>
                <div className="col-md-4">
                  <label>Alert User Sms Source Executive</label>
                  <StateManagedSelect
                    options={dropdowns.userSources}
                    value={
                      selectedAlertUserSmsSourceExecutiveOption !== null &&
                      selectedAlertUserSmsSourceExecutiveOption !== undefined
                        ? dropdowns.userSources.find(
                            (option) =>
                              option.value ==
                              selectedAlertUserSmsSourceExecutiveOption
                          ) || null
                        : null
                    }
                    onChange={(selected) =>
                      setSelectedAlertUserSmsSourceExecutiveOption(
                        selected ? selected.value : 0
                      )
                    }
                    placeholder="--select--"
                  />
                </div>
                <div className="col-md-4">
                  <label>Alert Lead Sms Executive</label>
                  <StateManagedSelect
                    options={dropdowns.smsTemplates}
                    value={
                      selectedAlertLeadSmsExecutiveOption !== null &&
                      selectedAlertLeadSmsExecutiveOption !== undefined
                        ? dropdowns.smsTemplates.find(
                            (option) =>
                              option.value ==
                              selectedAlertLeadSmsExecutiveOption
                          ) || null
                        : null
                    }
                    onChange={(selected) =>
                      setSelectedAlertLeadSmsExecutiveOption(
                        selected ? selected.value : 0
                      )
                    }
                    placeholder="--select--"
                  />
                </div>
                <div className="col-md-4">
                  <label>Alert User Push Executive</label>
                  <StateManagedSelect
                    options={dropdowns.pushTemplates}
                    value={
                      selectedAlertUserPushExecutiveOption !== null &&
                      selectedAlertUserPushExecutiveOption !== undefined
                        ? dropdowns.pushTemplates.find(
                            (option) =>
                              option.value ==
                              selectedAlertUserPushExecutiveOption
                          ) || null
                        : null
                    }
                    onChange={(selected) =>
                      setSelectedAlertUserPushExecutiveOption(
                        selected ? selected.value : 0
                      )
                    }
                    placeholder="--select--"
                  />
                </div>
                <div className="col-md-4">
                  <label>Alert Lead Whatsapp Subscriber</label>
                  <StateManagedSelect
                    options={dropdowns.whatsappTemplates}
                    value={
                      selectedAlertLeadWhatsappSubscriberOption !== null &&
                      selectedAlertLeadWhatsappSubscriberOption !== undefined
                        ? dropdowns.whatsappTemplates.find(
                            (option) =>
                              option.value ==
                              selectedAlertLeadWhatsappSubscriberOption
                          ) || null
                        : null
                    }
                    onChange={(selected) =>
                      setSelectedAlertLeadWhatsappSubscriberOption(
                        selected ? selected.value : 0
                      )
                    }
                    placeholder="--select--"
                  />
                </div>
                <div className="col-md-4">
                  <label>Alert User Whatsapp Executive</label>
                  <StateManagedSelect
                    options={dropdowns.whatsappTemplates}
                    value={
                      selectedAlertUserWhatsappExecutiveOption !== null &&
                      selectedAlertUserWhatsappExecutiveOption !== undefined
                        ? dropdowns.whatsappTemplates.find(
                            (option) =>
                              option.value ==
                              selectedAlertUserWhatsappExecutiveOption
                          ) || null
                        : null
                    }
                    onChange={(selected) =>
                      setSelectedAlertUserWhatsappExecutiveOption(
                        selected ? selected.value : 0
                      )
                    }
                    placeholder="--select--"
                  />
                </div>
                <div className="col-md-4">
                  <label>Alert Lead Email Subscriber</label>
                  <StateManagedSelect
                    options={dropdowns.emailTemplates}
                    value={
                      selectedAlertLeadEmailSubscriberOption !== null &&
                      selectedAlertLeadEmailSubscriberOption !== undefined
                        ? dropdowns.emailTemplates.find(
                            (option) =>
                              option.value ==
                              selectedAlertLeadEmailSubscriberOption
                          ) || null
                        : null
                    }
                    onChange={(selected) =>
                      setSelectedAlertLeadEmailSubscriberOption(
                        selected ? selected.value : 0
                      )
                    }
                    placeholder="--select--"
                  />
                </div>
              </div> */}

              <div className="row">
                <div className="col-md-12">
                  <SubmitButton
                    pageBack="/Workflow/LeadCreation"
                    handleSubmit={handleSubmit}
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddLeadCreationStreetfolioForm;
